import React from 'react';
import { Table } from '@tanstack/react-table';
import { SubmitHandler } from 'react-hook-form';
import { CompanyMembershipDto } from '@area-restrita/api-client/model/companyMembershipDto';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import DataTableToolbar from '@/components/DataTable/DataTableToolbar';
import DataGrid from '@/components/DataGrid';
import Dialog from '@/components/template/Dialog';
import { Button } from '@/components/ui/button';

import CompanyInviteForm from '../../components/CompanyInviteForm';
import { ICompanyInviteForm } from '../../components/CompanyInviteForm/schema';

interface IProps {
  table: Table<CompanyMembershipDto>;
  isLoading: boolean;
  onSubmit: SubmitHandler<ICompanyInviteForm>;
  canInvite: boolean;
}

const CompanyUsers: React.FC<IProps> = ({
  table,
  isLoading,
  canInvite,
  onSubmit,
}) => (
  <Card className="flex-1 flex flex-col h-full">
    <CardHeader>
      <CardTitle>Usuários</CardTitle>
      <CardDescription>
        Gerencie os usuários que possuem acesso a esta empresa.
      </CardDescription>
    </CardHeader>
    <CardContent className="p-0">
      <DataGrid
        table={table}
        isLoading={isLoading}
        actions={
          canInvite && (
            <Dialog
              title="Convidar Usuário"
              trigger={<Button size="sm">Convidar usuário</Button>}
            >
              <CompanyInviteForm onSubmit={onSubmit} />
            </Dialog>
          )
        }
        toolbar={
          <DataTableToolbar
            table={table}
            searchPlaceholder="Buscar membro..."
            searchColumnId="searchTerm"
          />
        }
      />
    </CardContent>
  </Card>
);

export default CompanyUsers;
